import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ytLogo from "../images/yt-logo.png";
import ytLogoMobile from "../images/yt-logo-mobile.png";

import { SlMenu } from "react-icons/sl";
import { IoIosSearch } from "react-icons/io";
import { RiVideoAddLine } from "react-icons/ri";
import { FiBell } from "react-icons/fi";
import { CgClose } from "react-icons/cg";

import { Context } from "../context/contextApi";
import Loader from "../shared/Loader";

const Header = () => {
  const [searchQuery, setSearchQuery] = useState("");
  // get provided data from context api
  const { loading, mobileMenu, setMobileMenu } = useContext(Context);

  const navigate = useNavigate();

  const searchQueryHandler = (event) => {
    if (
      (event?.key === "Enter" || event?.target.value === "searchButton") &&
      searchQuery?.length > 0
    ) {
      navigate(`/searchResults/${searchQuery}`);
    }
  };

  // for toggling menu for mobilr device
  const mobileMenuToggle = () => {
    setMobileMenu(!mobileMenu);
  };

  const { pathname } = useLocation();
  const pageName = pathname?.split("/").filter(Boolean)?.[0];

  return (
    <div className="sticky top-0 z-50 flex flex-row items-center justify-between h-14 px-4 md:px-5 bg-white dark:bg-black">
      {loading && <Loader />}

      <div className="flex h-5 items-center">
        {pageName !== "video" && (
          <div className="flex md:hidden md:mr-6 cursor-pointer items-center justify-center h-10 w-10 rounded-full hover:bg-[#303030]/[0.6]" onClick={mobileMenuToggle}>
            {mobileMenu ? (<CgClose className="text-white text-xl" />) : (<SlMenu className="text-white text-xl" />) }
          </div>
        )}

        <Link to="/" className="flex h-5 items-center">
          <img src={ytLogo} alt="Youtube Logo" className="h-full hidden md:block" />
          <img src={ytLogoMobile} alt="Youtube Logo" className="h-full md:hidden " />
        </Link>


      </div>
        <div className="group flex items-center">
          <div className="flex h-8 md:h-10 md:ml-5 md:pl-5 border border-gray-500 rounded-l-3xl group-focus-within:border-blue-500 " >

            <input type="text"
                  className="bg-transparent outline-none placeholder:text-white text-white pr-5 pl-5 md:pl-0 w-44 md:w-64 lg:w-[500px]"
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyUp={searchQueryHandler}
                  value={searchQuery}
                  placeholder="Search.."
            />
          </div>
          <button onClick={searchQueryHandler} value="searchButton" className="w-[44px] md:w-[60px] h-8 md:h-10 flex items-center justify-center border border-gray-500 rounded-r-3xl bg-[#303030]/[0.9]">
            <IoIosSearch className="text-white text-xl" />
          </button>
        </div>

        <div className="flex items-center">
          <div className="md:flex">
            <div className="items-center justify-center hidden md:flex h-10 w-10 rounded-full hover:bg-[#303030]/[0.6]">
              <RiVideoAddLine className="text-white text-xl cursor-pointer" />
            </div>
            <div className="items-center justify-center hidden md:flex ml-2 h-10 w-10 rounded-full hover:bg-[#303030]/[0.6]">
              <FiBell className="text-white text-xl cursor-pointer" />
            </div>
            <div className="h-8 w-8 rounded-full md:ml-4 ">
              <img src="https://i.pravatar.cc" alt="profile_img" className="rounded-full"/>
            </div>
          </div>
        </div>
    </div>
  );
};

export default Header;
